import axios from 'axios';
import { put, takeLatest, call } from 'redux-saga/effects';
import { exercises } from '../../BusinessLogic/Network/API/ExercisesApi';
//types
import * as types from '../ActionTypes/ExercisesActionTypes';
import { ExercisesActionCreators } from '../ActionCreators/ExercisesActionCreators';

export class ExercisesSaga {
    static *getAllExercises({ meta: { filter } }) {
        try {
            const _exercises = exercises.create();
            const { data: response } = yield call(axios, _exercises.getAllExercises(filter));

            let offsetId = 0;

            if (response.data.length) {
                offsetId = response.data[response.data.length - 1].exercise_id;
            }

            yield put(ExercisesActionCreators.getAllExercisesSuccess(response.data, offsetId));
        } catch (e) {
            console.log({ e });
        }
    }

    static *getMoreExercises({ meta: { filter, offsetId } }) {
        try {
            const _exercises = exercises.create();
            const { data: response } = yield call(axios, _exercises.getAllExercises(filter, offsetId));

            if (response.data.length) {
                let offsetId = response.data[response.data.length - 1].exercise_id;
                return yield put(ExercisesActionCreators.getMoreExercisesSuccess(response.data, offsetId));
            }

            yield put(ExercisesActionCreators.noMoreExercises());
        } catch (e) {
            console.log(e);
        }
    }

    static *getRecentExercises() {
        try {
            const _exercises = exercises.create();
            const { data: response } = yield call(axios, _exercises.getRecentExercises());

            yield put(ExercisesActionCreators.getRecentExercisesSuccess(response.data));
        } catch (e) {
            console.log(e);
        }
    }

    static *getExercisesByType({ meta: { key, filter } }) {
        try {
            console.log('PRIVETIKI');
            const _exercises = exercises.create();
            const { data: response } = yield call(axios, _exercises.getExercisesByType(key, filter));

            let offsetId = 0;
            if (response.data.length) {
                offsetId = response.data[response.data.length - 1].exercise_id;
            }

            yield put(ExercisesActionCreators.getExercisesByTypeSuccess(response.data, offsetId));
        } catch (e) {
            console.log(e);
        }
    }

    static *getMoreExercisesByType({ meta: { key, filter, offsetId } }) {
        try {
            const _exercises = exercises.create();
            const { data: response } = yield call(axios, _exercises.getExercisesByType(key, filter, offsetId));

            if (response.data.length) {
                let offsetId = response.data[response.data.length - 1].exercise_id;
                return yield put(ExercisesActionCreators.getMoreExercisesByTypeSuccess(response.data, offsetId));
            }

            yield put(ExercisesActionCreators.noMoreExercisesByType());
        } catch (e) {
            console.log(e);
        }
    }
}

export function* saga() {
    yield takeLatest(types.GET_ALL_EXERCISES_REQUEST, ExercisesSaga.getAllExercises);
    yield takeLatest(types.GET_RECENT_EXERCISES_REQUEST, ExercisesSaga.getRecentExercises);
    yield takeLatest(types.GET_EXERCISES_BY_TYPE_REQUEST, ExercisesSaga.getExercisesByType);
    yield takeLatest(types.GET_MORE_EXERCISES_REQUEST, ExercisesSaga.getMoreExercises);
    yield takeLatest(types.GET_MORE_EXERCISES_BY_TYPE_REQUEST, ExercisesSaga.getMoreExercisesByType);
}



// WEBPACK FOOTER //
// ./src/Store/Saga/ExercisesSaga.js